module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticClass: "client-login-account-modal"
  }, [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Update Client Login Account")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    staticClass: "client-login-account-modal__content"
  }, [_c('v-card-text', {
    staticClass: "client-login-account-modal__accounts"
  }, [_vm._l((_vm.existingAccounts), function(account, index) {
    return _c('v-list', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-text-field', {
      staticClass: "ma-0 pa-0",
      attrs: {
        "prepend-icon": "perm_identity",
        "label": "Client Login Email",
        "placeholder": "Create new Client Account",
        "value": account.email,
        "disabled": ""
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "prepend-icon": "security",
        "append-icon": account.show1 ? 'visibility' : 'visibility_off',
        "type": account.show1 ? 'text' : 'password',
        "label": "Enter Password",
        "hint": "Recommended for at least 8 characters",
        "counter": ""
      },
      on: {
        "click:append": function($event) {
          return _vm.updateAccShow(index)
        }
      },
      model: {
        value: (account.password),
        callback: function($$v) {
          _vm.$set(account, "password", $$v)
        },
        expression: "account.password"
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      staticClass: "justify-end",
      attrs: {
        "dense": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.removeExistingAccount(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete                         \n                ")], 1)], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "ma-0 pa-0"
    })], 1)
  }), _vm._v(" "), _vm._l((_vm.newAccounts), function(account, index) {
    return _c('v-list', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-select', {
      staticClass: "mb-2",
      attrs: {
        "items": account.newEmails,
        "item-text": "email",
        "outlined": "",
        "label": "Client Login Email",
        "dense": "",
        "hide-details": ""
      },
      on: {
        "change": function($event) {
          return _vm.checkAccEmail(index)
        }
      },
      model: {
        value: (account.email),
        callback: function($$v) {
          _vm.$set(account, "email", $$v)
        },
        expression: "account.email"
      }
    })], 1), _vm._v(" "), (account.invalid) ? _c('v-list-item', {
      staticStyle: {
        "margin-top": "-15px"
      },
      attrs: {
        "dense": ""
      }
    }, [_c('p', {
      staticClass: "pt-2 text-danger"
    }, [_vm._v("Email Already Exists.")])]) : _vm._e(), _vm._v(" "), _c('v-list-item', [_c('v-text-field', {
      attrs: {
        "prepend-icon": "security",
        "append-icon": account.show1 ? 'visibility' : 'visibility_off',
        "type": account.show1 ? 'text' : 'password',
        "label": "Enter Password",
        "hint": "Recommended for at least 8 characters",
        "counter": ""
      },
      on: {
        "click:append": function($event) {
          account.show1 = !account.show1
        }
      },
      model: {
        value: (account.password),
        callback: function($$v) {
          _vm.$set(account, "password", $$v)
        },
        expression: "account.password"
      }
    })], 1), _vm._v(" "), _c('v-list-item', {
      staticClass: "justify-end",
      attrs: {
        "dense": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "text": "",
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.removeNewAccount(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v("mdi-delete-forever")]), _vm._v("  Delete                         \n                ")], 1)], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "ma-0 pa-0"
    })], 1)
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "color": "info",
      "disabled": _vm.disableAddNew
    },
    on: {
      "click": function($event) {
        return _vm.addNewAccount()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" Add Account\n            ")], 1)], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "info",
    on: {
      "click": _vm.updateClientUser
    }
  }, [_vm._v("Save changes")])], 1), _vm._v(" "), _c('small', [_vm._v("*If client don't have the email address, the system will automatically create a login email.")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e5abced"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Client/UpdateClientUserModal.vue
// module id = 2028
// module chunks = 0